<template>
  <div class="container-fluid p-0 position-relative mb-5">
    <div class="w-100 news-masthead-content">
      <div class="owl-carousel owl-theme" id="newsMainmasthead">
        <div
          class="item"
          v-for="item_news in news_eps"
          :key="item_news.id"
          @click="goTo(checkLink(item_news))"
        >
          <div class="item_img">
            <img
              v-bind:src="item_news.img_link"
              @error="imageLoadError($event)"
            />
          </div>
          <div class="bg-overlay w-100 h-100">
            <div class="container-fluid pl-details">
              <div class="row h-100 align-items-end">
                <div class="col-12 col-md-10">
                  <div class="w-100 details-container d-flex flex-column">
                    <p
                      class="main-title mb-1 mb-md-2"
                      v-if="item_news.data.title"
                      :title="item_news.data.title"
                    >
                      <!-- <Trunquee :text="item_news.data.title" :speed="120" /> -->
                      {{ truncateString(item_news.data.title, 50) }}
                    </p>
                    <p
                      class="desc mb-2 mb-md-4"
                      v-if="item_news.data.description"
                      :title="item_news.data.description"
                    >
                      <span class="d-none d-md-block">{{
                        truncateString(item_news.data.description, 220)
                      }}</span>
                      <span class="d-block d-md-none">{{
                        truncateString(item_news.data.description, 150)
                      }}</span>
                    </p>
                    <div
                      class="custom-btn mt-2"
                      @click="goTo(checkLink(item_news))"
                    >
                      <div
                        class="w-100 d-flex flex-row align-items-center justify-content-center"
                      >
                        <img
                          src="@/assets/icon/icon-play.svg"
                          class="btn-icon"
                        />
                        <span class="ml-2 play-text"> Play now</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="owl-theme">
        <div class="owl-controls d-md-block d-none">
          <div class="custom-nav owl-nav"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";

export default {
  data: function() {
    return {
      news_eps: [],
    };
  },
  created: function() {
    this.$store.dispatch("fetchNews", { self: this });
  },
  methods: {
    filterNews() {
      var vm = this;
      vm.news_eps = this.$store.state.news_eps.data;

      var store = [];

      vm.news_eps.forEach((item) => {
        if (
          item.idSchema == "205" ||
          item.idSchema == "206" ||
          item.idSchema == "207" ||
          item.idSchema == "208" ||
          item.idSchema == "209"
        ) {
          item["img_link"] = this.imgFilteringForMasthead(item, 900);
          store.push(item);
        }
      });

      vm.news_eps = store;

      Vue.nextTick(
        function() {
          vm.installOwlCarouselForMasthead("#newsMainmasthead");
        }.bind(vm)
      );
    },

    imgFilteringForMasthead(item, size) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/" +
          size +
          "x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/" +
            size +
            "x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/" +
              size +
              "x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://cdn-rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/" +
              size +
              "x0/images.title";
          }
        }
      }
      return imgurl;
    },
    goTo(link) {
      this.$router.push(link);
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;
      var firstEpisode;
      var link;

      if (item.data["news-episode"]) {
        const availableData = item.data["news-episode"];
        availableData.sort(function(a, b) {
          return b.id - a.id;
        });
        firstEpisode = availableData[0].id;
      }

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=" +
          firstEpisode;
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
        // console.log(link);
      }

      return link;
    },

    installOwlCarouselForMasthead: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: false,
        center: true,
        navText: [
          '<div class="border-nav"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
          '<div class="border-nav"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        ],
        navContainer: ".news-masthead-content .custom-nav",
        dots: true,
        margin: 0,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: false,
            dots: false,
          },
          768: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: false,
            autoplay: false,
            // autoplayTimeout: 3000,
          },
          990: {
            items: 1,
            stagePadding: 0,
            margin: 0,
            loop: true,
            nav: true,
            autoplay: false,
            // autoplayTimeout: 3000,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.item {
  cursor: pointer;
  position: relative;
}
.item .item_img {
  /* width: 100%; */
  overflow: hidden;
  position: relative;
  /* padding-top: calc(835 / 1594 * 100%); */
  height: 830px;
  -webkit-mask-image: linear-gradient(
    to top,
    rgba(25, 25, 25, 0.12222) 5%,
    rgba(25, 25, 25, 0.911111) 100%
  );
  mask-image: linear-gradient(
    to top,
    rgba(25, 25, 25, 0.12222) 5%,
    rgba(25, 25, 25, 0.911111) 100%
  );
}
.item .item_img img {
  background: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  border-radius: 12px;
}
.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(0, 0, 0);
  background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 13.16%);
}
.pl-details {
  padding-left: 7.2rem !important;
}
.details-container {
  max-width: 700px;
  margin-bottom: 12rem;
}

.main-title {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  color: rgba(250, 185, 19, 1);
  text-align: left;
}
.desc {
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: #ffffff;
}
.custom-btn {
  background: rgba(250, 185, 19, 1);
  border: none;
  border-radius: 12px;
  color: #000000;
  font-size: 14px;
  line-height: 16px;
  padding: 8px 24px;
  max-width: 200px;
  width: fit-content;
}
.btn-icon {
  width: 40px !important;
}

.category-section {
  padding: 10px 21px;
  background: rgba(0, 0, 0, 0.6);
  border-left: 2px solid #f9b92b;
  margin: 60% 0 0 0;
}
.category-text {
  font-size: 19px;
  font-weight: bold;
  line-height: 1.21;
  text-align: left;
  color: #f9b91b;
}
.play-text {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: rgba(0, 0, 0, 1);
}
@media only screen and (max-width: 992px) {
  .category-section {
    padding: 6px 12px;
  }
  .category-text {
    font-size: 11px;
    line-height: 1.21;
  }
}

@media only screen and (max-width: 768px) {
  .details-container {
    margin-bottom: 4rem;
  }
  .main-title {
    font-size: 18px;
    line-height: 20px;
    font-family: "Poppins", sans-serif !important;
    padding-bottom: 4px;
  }
  .desc {
    font-size: 16px;
    line-height: 20px;
    font-family: "Poppins", sans-serif !important;
  }

  .item .item_img {
    width: 100%;
    height: 528px;
  }
  .pl-details {
    padding-left: 16px !important;
  }

  .custom-btn {
    background: rgba(250, 185, 19, 1);
    border: none;
    border-radius: 12px;
    color: #000000;
    font-size: 12px;
    line-height: 16px;
    padding: 4px 8px;
    max-width: 200px;
    width: fit-content;
  }
  .btn-icon {
    width: 30px !important;
  }

  .play-text {
    font-size: 12px;
  }
}
</style>
<style>
.news-masthead-content {
  max-width: 100%;
  height: 830px;
  background: black;
  border-radius: 12px;
  padding: 12px;
  overflow: hidden;
}
.news-masthead-content .owl-theme .owl-dots {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translate(-50%, -11%);
}
.news-masthead-content .owl-theme .owl-dots .owl-dot span {
  width: 22px;
  height: 5px;
  margin: 5px;
  background: #869791;
}
.news-masthead-content .owl-theme .owl-dots .owl-dot.active span,
.news-masthead-content .owl-theme .owl-dots .owl-dot:hover span {
  background: #fab92b;
}

.news-masthead-content .owl-theme .custom-nav .owl-prev,
.news-masthead-content .owl-theme .custom-nav .owl-next {
  position: absolute;
  color: inherit;
  background: rgba(15, 15, 15, 1);
  border: none;
  z-index: 100;
  bottom: 56px;
  border-radius: 8px;
  width: 56px;
  height: 56px;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-masthead-content .owl-theme .custom-nav .owl-prev:hover,
.news-masthead-content .owl-theme .custom-nav .owl-next:hover {
  background: #fab92b;
}

.news-masthead-content .owl-theme .custom-nav .owl-prev .border-nav,
.news-masthead-content .owl-theme .custom-nav .owl-next .border-nav {
  width: 46px;
  height: 46px;
}
.news-masthead-content .owl-theme .custom-nav .owl-prev .border-nav i,
.news-masthead-content .owl-theme .custom-nav .owl-next .border-nav i {
  font-size: 2.4rem;
  color: rgba(255, 255, 255, 1);
  padding: 0 10px;
}
.news-masthead-content .owl-theme .custom-nav .owl-prev {
  left: 16px;
  display: flex;
  justify-content: center;
}
.news-masthead-content .owl-theme .custom-nav .owl-next {
  right: 16px;
  display: flex;
  justify-content: center;
}
.news-masthead-content
  .owl-theme
  .owl-stage-outer
  .owl-stage
  .owl-item:not(.center)
  > div {
  opacity: 0.25;
  z-index: 5;
}
@media only screen and (max-width: 768px) {
  .news-masthead-content {
    height: 600px;
  }
  .news-masthead-content .owl-theme .owl-dots {
    position: absolute;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
  .news-masthead-content .owl-theme .owl-dots .owl-dot span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .news-masthead-content {
    height: 528px;
  }
  .news-masthead-content .owl-theme .owl-dots {
    position: absolute;
    bottom: 3%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }
  .news-masthead-content .owl-theme .owl-dots .owl-dot span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin: 4px;
  }
}
</style>
